/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import TechnicalErrorForm from "../../TechStatus/TechnicalErrorForm";
import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import PauseBeaRetries from "./BeaRetries/PauseBeaRetries";
import BeaFetchInbox from "./BeaFetchInbox/BeaFetchInbox";
import CalendlyClear from "./Calendly/CalendlyClear";
import EmailProcessing from "./EmailProcessing/EmailProcessing";
import AlgoliaIndexUpdate from "./AlgoliaIndexUpdate/AlgoliaIndexUpdate";
import ImportEConsultDossier from "../../ImportEConsultDossier/ImportEConsultDossier";
import BuschbellTestMail from "./BuschbellTestMail/BuschbellTestMail";

export default function TechBoard() {
  return (
    <PageContentContainer size="tiny">
      <PageHeadline main="Tech-Board" />
      <TechnicalErrorForm />
      <BeaFetchInbox />
      <PauseBeaRetries />
      <CalendlyClear />
      <EmailProcessing />
      {import.meta.env.VITE_DEPLOYMENT === "testing" && <BuschbellTestMail />}
      <AlgoliaIndexUpdate />
      <ImportEConsultDossier />
    </PageContentContainer>
  );
}
